// MARK: NPM Modules
import styled from "styled-components";

// MARK: Styled Components
interface PageBoundingBoxContainerProps {
  maximumBodyWidth: number
  margin: number;
  paddingTop: number;
}

const PageBoundingBoxContainer = styled.main<PageBoundingBoxContainerProps>`
  width: ${({ margin }) => "calc(100% - "  + 2*margin + "px)"};
  max-width: ${({ maximumBodyWidth }) => maximumBodyWidth}px;
  height: auto;
  margin: auto;
  margin-top: ${({ paddingTop }) => paddingTop}px;
  background-color: transparent;
`;

export default PageBoundingBoxContainer;
